import axiosApi from "./api";
export function postAction(url, parameter) {
  return axiosApi({
    url: url,
    method: "post",
    data: parameter,
  });
}

//put
export function putAction(url, parameter) {
  return axiosApi({
    url: url,
    method: "put",
    data: parameter,
  });
}

//put
export function putActionQuery(url, parameter) {
  return axiosApi({
    url: url,
    method: "put",
    params: parameter,
  });
}

//get
export function getAction(url, parameter) {
  return axiosApi({
    url: url,
    method: "get",
    params: parameter,
  });
}

//deleteAction
export function deleteAction(url, parameter) {
  return axiosApi({
    url: url,
    method: "delete",
    params: parameter,
  });
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return axiosApi({
    url: url,
    params: parameter,
    method: "get",
    responseType: "blob",
  });
}

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = "http";
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar;
    } else {
      if (avatar && avatar.length > 0 && avatar.indexOf("[") == -1) {
        return window._CONFIG["staticDomainURL"] + "/" + avatar;
      }
    }
  } catch (err) {
    return;
  }
}

/**
 * 文件上传
 * @param {请求地址} url
 * @param {请求方式} method
 * @param {文件流} parameter
 */
export function uploadAction(url, method, parameter) {
  let formdata = new FormData();
  formdata.append("file", parameter);
  if (method === "get" || method === "put" || method === "delete") {
    return axiosApi({
      url: url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: method,
      params: formdata,
    });
  }
  if (method === "post") {
    return axiosApi({
      url: url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: method,
      data: formdata,
    });
  }
}

export const handleDownFile = (url, filename, parameter) => {
  return downFile(url, parameter).then((res) => {
    const blob = new Blob([res], {
      type: res.type,
    });
    const nav = window.navigator;
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, filename);
    } else {
      var blobURL = window.URL.createObjectURL(blob);
      // 创建隐藏<a>标签进行下载
      var tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = blobURL;
      tempLink.setAttribute("download", filename);
      if (typeof tempLink.download === "undefined") {
        tempLink.setAttribute("target", "_blank");
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink); // 移除dom元素
      window.URL.revokeObjectURL(blobURL); // 释放bolb内存
    }
  });
};
